import { render, staticRenderFns } from "./AddTeamLevel.vue?vue&type=template&id=a954c2f2&scoped=true"
import script from "./AddTeamLevel.vue?vue&type=script&lang=js"
export * from "./AddTeamLevel.vue?vue&type=script&lang=js"
import style0 from "./AddTeamLevel.vue?vue&type=style&index=0&id=a954c2f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a954c2f2",
  null
  
)

export default component.exports